<div class="modal in hs-composition-overwrite-dialog" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog" style="max-width: 65em;">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">{{'COMPOSITIONS.cswDialog.loadComposition' | translateHs }}
                </h4>
                <button type="button" (click)="close()" class="btn-close" data-dismiss="modal"
                    [attr.aria-label]="'COMMON.close' | translateHs ">
                </button>
            </div>
            <p class="py-3 text-danger m-auto w-75 ps-3">
                {{'COMPOSITIONS.cswDialog.infoText' | translateHs }}
            </p>
            <div class="modal-body w-75 mh-75" style="max-height: 75vh; overflow-y: auto; margin:auto">
                <div ngbAccordion [closeOthers]="true" #acc="ngbAccordion" (show)="beforeChange($event)">
                    <div [ngbAccordionItem]="service.id" [collapsed]="true" [disabled]="!servicesLoaded"
                        [id]="service.id" *ngFor="let service of data.services" (hide)="service.selected = false">
                        <div ngbAccordionHeader>
                            <button ngbAccordionButton *ngIf="service.loaded; else loadingLayers"
                                class="accordion-button justify-content-between">{{service.title}}
                                <span class="ml-auto pe-3">
                                    <i class="icon-trash text-secondary" role="button"
                                        (click)="$event.stopPropagation();removeService(service)"
                                        [title]="'COMMON.delete' | translateHs"></i>
                                </span>
                            </button>
                            <ng-template #loadingLayers>
                                <button
                                    class="accordion-button justify-content-between">{{'COMPOSITIONS.cswDialog.servicesLoading'
                                    | translateHs}}&emsp;<span class="hs-loader ml-auto"></span></button>
                            </ng-template>
                        </div>
                        <div ngbAccordionCollapse>
                            <div ngbAccordionBody>
                                <ng-template>
                                    <hs-layer-table *ngIf="service.loaded && service.selected" [type]="service.type"
                                        [injectedService]="service.typeService"> </hs-layer-table>
                                </ng-template>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="w-75 mh-75 m-auto p-3" [hidden]="layersString.length === 0">
                {{'COMPOSITIONS.cswDialog.otherLayers' | translateHs }}: {{layersString}}
            </div>

            <div class="modal-footer">
                <button (click)="addLayers()" [disabled]="!servicesLoaded" type="button" class="btn btn-primary"
                    data-dismiss="modal">{{'COMMON.addLayers' |
                    translateHs }}</button>
                <button (click)="close()" type="button" class="btn btn-primary" data-dismiss="modal">{{'COMMON.cancel'
                    | translateHs }}</button>
            </div>
        </div>
    </div>
</div>